eula.classy.controller({
    name: 'EulaController',
    inject: ['$scope', '$rootScope', '$location', 'StandardCudFactory', 'SchoolModelService', 'FeeAgreementModelService', 'BinFactory'],
    init: function()
    {
        this.$.SchoolModelService = this.SchoolModelService;
        this.$.item = this.SchoolModelService.data[0];
        this.$rootScope.model = this.SchoolModelService;
        this.$.eulainfo = this.FeeAgreementModelService.get()[0];
        var newdate = new Date(this.$.item.CreationDate);
        this.$.creationDate = newdate.getMonth()+1 + '-' + newdate.getDate() + '-' + newdate.getFullYear();
    },
    agree: function()
    {
        if(this.$.item.eula == 1)
        {
            this.$.item.now = true;
            this.$.item.eula_date = new Date().getDateMySqlFormatted();
        }
        else
        {
            delete this.$.item.now;
            this.$.item.eula_date = '0000-00-00';
        }
    },
   submit: function(scope, instance, form)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.SchoolModelService.put(this.id, this.$.item, instance).then(function (response) {

            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.SchoolModelService.set(this.SchoolModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    eulaPrint: function() {
        var mywindow = window.open('', 'Eula', 'height=500,width=800');
        mywindow.document.write('<html><head><title>Eula</title>');
        mywindow.document.write('</head><body>');
        mywindow.document.write($(".scroll-well").html());
        mywindow.document.write('</body></html>');

        mywindow.print();
        mywindow.close();

        return true;
    }
});

